import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as C from './constants'

export const initialState = {
  action: null,
  paymentToken: createAsyncObject({}),
  paymentCharges: createAsyncObject({})
}

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case C.CREATE_PAYMENT_TOKEN_REQUEST:
      draftState.action = action.type
      updateForAsyncRequest(draftState.paymentToken)
      break
    case C.CREATE_PAYMENT_TOKEN_SUCCESS:
      draftState.action = action.type
      // as we are only interested in tracking the ui state when creating the payment token,
      // setting success payload to null will not affect the payment process flow and it is meant
      // for preventing sensitive information to be populated into the redux store
      updateForAsyncSuccess(null)(draftState.paymentToken)
      break
    case C.CREATE_PAYMENT_TOKEN_FAILURE:
      draftState.action = action.type
      updateForAsyncFailure(action)(draftState.paymentToken)
      break
    case C.POST_STRIPE_CHARGES_REQUEST:
      draftState.action = action.type
      updateForAsyncRequest(draftState.paymentCharges)
      break
    case C.POST_STRIPE_CHARGES_SUCCESS:
      draftState.action = action.type
      updateForAsyncSuccess(action.payload)(draftState.paymentCharges)
      break
    case C.POST_STRIPE_CHARGES_FAILURE:
      draftState.action = action.type
      updateForAsyncFailure(action)(draftState.paymentCharges)
      break
  }
})
